const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('viewMore', ['Application', '$translate', function (Application, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contents: "=",
    },
    template: require('../../templates/directives/view-more.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};
      self.showAll = false;
      self.toggleVisibility = function(){
        self.showAll = !self.showAll;
      };
      self.getContentLink = function (content) {
        if(!content.link) {
          return '#/explore';
        }
        if(content.archived) {
          Application.messaging.addMessage({status: 'error', duration: 7, text: self.translations['adminUserAssigned.item_archived']});
          return '#/explore';
        }
        return `#${content.link}`;
      };
      $translate([
        'adminUserAssigned.item_archived'
      ]).then(function (translations) {
        self.translations = translations;
      });
    }],
    controllerAs: 'vm'
  };
}]);
